import { AppShell } from '../shared/ui/AppShell'
import { SourceList } from '../features/sources/ui/SourceList'
import { useSourcesController } from '../features/sources/state/useSourcesController'

export function SourcesPage() {
  const controller = useSourcesController()

  return (
    <AppShell showAnalytics={false}>
      <div className="mx-auto w-full max-w-[1000px] px-4 py-4 sm:px-6 sm:py-6">
        <SourceList
          sources={controller.sources}
          total={controller.total}
          query={controller.query}
          onSearchChange={controller.onSearchChange}
          onPlatformChange={controller.onPlatformChange}
          onIsEnabledChange={controller.onIsEnabledChange}
          onSortChange={controller.onSortChange}
          onPageChange={controller.onPageChange}
          onCreate={controller.createSource}
          onUpdate={controller.updateSource}
          onDelete={controller.deleteSource}
          isLoading={controller.isLoading}
        />
      </div>
    </AppShell>
  )
}
